import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import BaseAPI from '../../api/apiurl';

const ApexChatPTask = () => {
  const [options, setOptions] = useState({
    series: [100],
    chart: {
      height: 350,
      type: 'radialBar',
      toolbar: {
        show: true,
      },
    },
    plotOptions: {
      // Your plot options here...
    },
    fill: {
      // Your fill options here...
    },
    stroke: {
      lineCap: 'round',
    },
    labels: ['Completion Percent'],
  });

  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      try {
        const company_id = localStorage.getItem('companyid');
        const customer_id = localStorage.getItem('customerid');

        if (company_id && customer_id) {
          const response = await fetch(`${BaseAPI}projectperc?company_id=${company_id}&customer_id=${customer_id}`);
          const data = await response.json();

          if (data.status === 200 && data.data.length > 0) {
            const completedPercentage = Math.round(data.data[0].completed_percentage);

            // Update the series data
            setOptions((prevOptions) => ({
              ...prevOptions,
              series: [completedPercentage],
            }));
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData(); // Call the fetch function when the component mounts
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <div id="chart">
      <Chart options={options} series={options.series} type="radialBar" height={400} />
    </div>
  );
};

export default ApexChatPTask;

